import posthog, { type Properties } from 'posthog-js';

let initialized = false;

export function initPostHog(apiKey: string, options?: { host?: string; app?: string }): void {
  if (initialized || !apiKey) return;

  posthog.init(apiKey, {
    api_host: options?.host ?? 'https://us.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    disable_session_recording: false,
  });

  if (options?.app) {
    posthog.register({ app: options.app });
  }

  initialized = true;
}

export function identifyUser(userId: string, properties?: Properties): void {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

export function setGroup(groupType: string, groupKey: string, properties?: Properties): void {
  if (!initialized) return;
  posthog.group(groupType, groupKey, properties);
}

export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}

export function captureEvent(event: string, properties?: Properties): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function isFeatureEnabled(flag: string): boolean {
  if (!initialized) return false;
  return posthog.isFeatureEnabled(flag) ?? false;
}

export { posthog };
